import React, { useEffect, useRef, useState } from "react";
import { MyCampaignsImg } from "../../../static/constant/imgConstants";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import CampaignDate from "../BrandCampaignCreation/CampaignDate";
import DatePicker from "react-datepicker";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { uploadCampaignFile } from "../../../store/campaignStore/actions/CreateCampaignActions/uploadCampaignFileActions";
import { uploadReferenceVideo } from "../../../store/campaignStore/actions/CreateCampaignActions/uploadReferenceVideoActions";
import { useToast } from "../../../hooks/useToast";

const Bgc = ({
    videoTitle,
    setVideoTitle,
    videoDescription,
    setVideoDescription,
    mediaFileLink,
    setMediaFileLink,
    mediaFileName,
    setMediaFileName,

    startDate,
    setStartDate,
    endDate,
    setEndDate,
    errors,
    setErrors,
    loading,
    setLoading,
    brandId,
    userType,
    referenceVideoUpload,
    setReferenceVideoUpload,
    setReferenceVideoFile,
    descriptionLink,
    setDescriptionLink,
}) => {
    const dispatch = useDispatch();
    const Toast = useToast();
    const getUserInfoReducerData = useSelector(state => state.getUserInfoReducer.data);
    const datePickerRef = useRef(null);

    const [fileName, setFileName] = useState(mediaFileName);
    const [isDragActive, setIsDragActive] = useState(false);
    const [refVideoFileName, setRefVideoFileName] = useState('');



    // ── File upload handlers (same as UGC) ────────────────────────────────────
    // Modified: Added video type and duration validation
    const handleFileUpload = (file) => {
        if (!file || !file.type.startsWith("video/")) {
            setErrors((prevState) => ({
                ...prevState,
                mediaFileLink: "Please upload a valid video file",
            }));
            return;
        }

        setLoading(true); // Start loading
        const localUrl = URL.createObjectURL(file); // Create local URL for preview
        setFileName(file.name); // Set the video file name for display

        const videoElement = document.createElement("video");
        videoElement.src = localUrl;
        videoElement.preload = "metadata";


        videoElement.onloadedmetadata = () => {
            URL.revokeObjectURL(videoElement.src);
            const duration = Math.round(videoElement.duration);

            if (duration < 10 || duration > 180) {
                setErrors((prevState) => ({
                    ...prevState,
                    mediaFileLink: "Video duration must be between 10 seconds and 3 minutes",
                }));
                setLoading(false);
                setFileName(null);
                return; // Stop execution if video duration is invalid
            }

            const payload = {
                file: file,
                duration: duration,
                isBgc: true,
                brandId,
                userType: userType || getUserInfoReducerData?.userType
            };

            dispatch(
                uploadCampaignFile(payload, (response, status) => {
                    if (status === 200) {
                        setMediaFileName(file.name);
                        setMediaFileLink(response);
                        setLoading(false);
                        setErrors((prevState) => {
                            const { ["mediaFileLink"]: _, ...updatedObject } = prevState;
                            return updatedObject;
                        });
                    } else {
                        setLoading(false);
                        Toast(response, "error");
                    }
                })
            );
        };
    };

    const handleFileRemove = () => {
        setFileName("");
        setMediaFileLink("");
        setMediaFileName("");
        URL.revokeObjectURL(mediaFileLink);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragActive(true);
    };

    const handleDragLeave = () => {
        setIsDragActive(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragActive(false);
        const file = e.dataTransfer.files[0];
        handleFileUpload(file);
    };



    return (
        <div className="w-full">
            <h1 className="text-[1.6rem] text-[#111729] inter-font font-[400]">
                Brand Generated Content Campaign
            </h1>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-[2%] items-start w-full">

                {/* ── Video Title ───────────────────────────────────────────────── */}
                <div className="w-full mb-[2rem]">
                    <label className="text-[1.6rem] text-[#111729] inter-font font-[400] leading-relaxed pb-2">
                        Video Title
                        <span className=" text-[1.6rem] inter-font font-[400] text-[#E3351D]">
                            *
                        </span>
                    </label>
                    <input
                        type="text"
                        value={videoTitle}
                        readOnly={false}
                        onChange={(e) => {
                            setVideoTitle(e.target.value);
                            if (errors?.videoTitle) {
                                setErrors((prevState) => {
                                    const { videoTitle, ...updatedObject } = prevState;
                                    return updatedObject;
                                });
                            }
                        }}
                        placeholder="Enter Video Title"
                        className="w-full border border-gray-300 text-[1.6rem] inter-font font-[400] mt-[1rem] rounded-lg p-4 bg-white text-gray-900 shadow-sm"
                    />
                    {errors?.videoTitle && (
                        <p className="text-red-500 text-[1.6rem] inter-font font-[400]">
                            {errors?.videoTitle}
                        </p>
                    )}
                </div>

                {/* ── Video Description ─────────────────────────────────────────── */}
                <div className="w-full mb-[2rem]">
                    <label className="text-[1.6rem] text-[#111729] inter-font font-[400] leading-relaxed pb-2">
                        Video Description
                        <span className="text-[1.6rem] inter-font font-[400] text-[#E3351D]">
                            *
                        </span>
                    </label>
                    <textarea
                        value={videoDescription}
                        readOnly={false}
                        onChange={(e) => {
                            setVideoDescription(e.target.value);
                            if (errors?.videoDescription) {
                                setErrors((prevState) => {
                                    const { videoDescription, ...updatedObject } = prevState;
                                    return updatedObject;
                                });
                            }
                        }}
                        placeholder="Enter Video Description"
                        className="w-full min-h-[12rem] border border-gray-300 text-[1.6rem] inter-font font-[400] mt-[1rem] rounded-lg p-4 bg-white text-gray-900 shadow-sm resize-y"
                    />
                    {errors?.videoDescription && (
                        <p className="text-red-500 text-[1.6rem] inter-font font-[400]">
                            {errors?.videoDescription}
                        </p>
                    )}
                </div>

                {/* ── Reference Content Upload (same as UGC) ───────────────────── */}
                <div className="w-full flex flex-col mb-[2rem]">
                    {/* Modified: Renamed label for BGC and fixed label clipping */}
                    <label className="text-[1.6rem] text-[#111729] inter-font font-[400] leading-relaxed pb-2">
                        Content to be Published (video only)
                        <span className="text-red-500">*</span>
                    </label>
                    <div
                        className={`w-full flex flex-col justify-center items-center h-[12rem] border ${isDragActive ? "border-blue-500 bg-blue-50" : "border-gray-300"
                            } mt-[0.5rem] rounded-lg p-6 text-center ${mediaFileLink ? "" : "cursor-pointer"
                            }`}
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                    >
                        {/* Modified: Restricted to video only */}
                        <input
                            type="file"
                            accept="video/*"
                            className="hidden"
                            onChange={(e) => handleFileUpload(e.target.files[0])}
                            id="bgcFileUpload"
                        />
                        {loading ? (
                            <p className="text-[1.6rem] text-[#111729] inter-font font-[400]">
                                Uploading...
                            </p>
                        ) : mediaFileLink ? (
                            <div className="w-full text-center">
                                <p className="text-[1.4rem] inter-font font-[400] text-[#111729] mb-4">
                                    {fileName}
                                </p>
                                <button
                                    onClick={handleFileRemove}
                                    className="text-[#FF4D4F] font-medium hover:underline text-[1.4rem]"
                                >
                                    Remove File
                                </button>
                            </div>
                        ) : (
                            <label htmlFor="bgcFileUpload" className="cursor-pointer">
                                <p
                                    className={`text-[1.4rem] inter-font font-[400] ${isDragActive ? "text-blue-600" : "text-[#111729]"
                                        }`}
                                >
                                    {isDragActive ? "Drop file here" : ""}
                                </p>
                                {!isDragActive ? (
                                    <p className="text-[1.4rem] inter-font font-[400] text-[#111729]">
                                        Drag files here <br />
                                        or{" "}
                                        <span className="text-[1.4rem] inter-font font-[400] text-[#34A853]">
                                            browse your computer
                                        </span>
                                    </p>
                                ) : (
                                    ""
                                )}
                            </label>
                        )}
                    </div>
                    {errors?.mediaFileLink && (
                        <p className="text-red-500 text-[1.6rem] inter-font font-[400]">
                            {errors?.mediaFileLink}
                        </p>
                    )}
                </div>

                {/* ── Campaign Dates ────────────────────────────────────────────── */}
                <CampaignDate
                    startDate={startDate}
                    endDate={endDate}
                    errors={errors}
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                    setErrors={setErrors}
                    type={"VIDEO"}
                />



                {/* ── Reference Guidance Video Upload (optional) ────────────────── */}
                <div className="w-full mb-[2rem]">
                    <label className="text-[1.6rem] text-[#111729] inter-font font-[400] leading-relaxed pb-2">
                        Reference Guidance Video
                        <span className="text-[1.4rem] text-gray-400 ml-2">(optional)</span>
                    </label>
                    <div className="flex items-center gap-4 mt-[1rem]">
                        <input
                            type="file"
                            accept="video/*"
                            className="hidden"
                            id="refVideoUpload"
                            onChange={(e) => {
                                const selectedFile = e.target.files[0];
                                if (selectedFile) {
                                    if (!selectedFile.type.startsWith("video/")) {
                                        setErrors((prevState) => ({
                                            ...prevState,
                                            referenceVideoUpload: "Please upload a valid video file for reference guidance",
                                        }));
                                        return;
                                    }
                                    setErrors((prevState) => {
                                        const { ["referenceVideoUpload"]: _, ...updatedObject } = prevState;
                                        return updatedObject;
                                    });
                                    setLoading(true);
                                    setRefVideoFileName(selectedFile.name);
                                    dispatch(uploadReferenceVideo({ file: selectedFile }, (status, response, message) => {
                                        if (status === 200) {
                                            setReferenceVideoUpload(response);
                                            setLoading(false);
                                        } else {
                                            Toast(message || "Upload failed", "error");
                                            setLoading(false);
                                            setReferenceVideoUpload('');
                                            setRefVideoFileName('');
                                        }
                                    }));
                                }
                            }}
                        />
                        <label
                            htmlFor="refVideoUpload"
                            className={`cursor-pointer border border-gray-300 rounded-lg px-6 py-3 text-[1.4rem] text-[#111729] inter-font font-[400] hover:bg-gray-50 ${loading ? 'opacity-50 pointer-events-none' : ''}`}
                        >
                            {loading ? "Uploading..." : "Choose Video"}
                        </label>
                        {refVideoFileName ? (
                            <span className="text-[1.4rem] text-gray-600 inter-font font-[400] truncate max-w-[24rem]">
                                {refVideoFileName}
                            </span>
                        ) : referenceVideoUpload ? (
                            <span className="text-[1.4rem] text-blue-600 inter-font font-[400]">Video Uploaded</span>
                        ) : null}
                        {(refVideoFileName || referenceVideoUpload) && (
                            <button
                                type="button"
                                onClick={() => { setReferenceVideoFile(null); setReferenceVideoUpload(''); setRefVideoFileName(''); }}
                                className="text-[1.2rem] text-red-500 hover:underline"
                            >
                                Remove
                            </button>
                        )}
                    </div>
                    {errors?.referenceVideoUpload && (
                        <p className="text-red-500 text-[1.4rem] inter-font font-[400] mt-1">
                            {errors?.referenceVideoUpload}
                        </p>
                    )}
                </div>

                {/* ── Description Link (optional) ───────────────────────────────── */}
                {/* <div className="w-full mb-[2rem]">
                    <label className="text-[1.6rem] text-[#111729] inter-font font-[400] leading-relaxed pb-2">
                        Description Link
                        <span className="text-[1.4rem] text-gray-400 ml-2">(optional)</span>
                    </label>
                    <input
                        type="url"
                        value={descriptionLink || ''}
                        onChange={(e) => setDescriptionLink(e.target.value)}
                        placeholder="https://example.com/reference"
                        className="w-full border border-gray-300 text-[1.6rem] inter-font font-[400] mt-[1rem] rounded-lg p-4 bg-white text-gray-900 shadow-sm"
                    />
                </div> */}

            </div>
        </div>
    );
};

export default Bgc;
